module.exports = __webpack_public_path__ + "media/img/logos/2023/halloween-4bfc29ccdc49f6ca467a132dd36bc6d9.svg";